<template>
  <div>
    <van-nav-bar
      :title="$t('app.forget.forgetpass')"
      :left-text="$t('app.common.back')"
      left-arrow
      @click-left="$router.push('/login')"
    />
    <div class="wrap">
      <div class="logo">
        <img
          :src="$store.state.login_logo_url"
          style="width: 100%"
          v-if="$store.state.login_logo_url"
        />
        <img
          :src="require('../assets/images/' + $store.state.login_logo_img)"
          style="width: 100%"
          v-if="!$store.state.login_logo_url"
        />
      </div>
      <van-form @submit="onForget">
        <van-field
          v-model="phone"
          type="tel"
          name="phone"
          :label="$t('app.forget.phone')"
          :placeholder="$t('app.forget.phone_placeholder')"
          autocomplete="off"
        />
         <van-field
          v-model="rePicCode"
          center
          clearable
          :label="$t('app.forget.verification_code')"
          :placeholder="$t('app.forget.verification_code_placeholder')"
        >
          <div slot="button">
            <img
              :src="captcha"
              @click="this.getCaptcha"
              style="height: 25px; width: 80px"
            />
          </div>
        </van-field>
        <van-field
          v-model="sms"
          type="digit"
          center
          clearable
          :label="$t('app.forget.get_code_sms')"
          :placeholder="$t('app.forget.get_code_placeholder')"
          autocomplete="off"
        >
          <template #button>
            <van-button
              size="small"
              plain
              type="info"
              native-type="button"
              :disabled="disabled"
              @click="getRealName"
              >{{ getCodeText }}</van-button
            >
          </template>
        </van-field>
        <van-field
          v-model="password"
          type="password"
          name="password"
          :label="$t('app.forget.password')"
          :placeholder="$t('app.forget.password_placeholder')"
          autocomplete="off"
        />
        <van-field
          v-model="verify"
          type="password"
          name="password"
          :label="$t('app.forget.passwordConfirm')"
          :placeholder="$t('app.forget.passwordConfirm_placeholder')"
          autocomplete="off"
        />
        <div style="margin: 16px">
          <van-button
            round
            block
            type="danger"
            size="small"
            native-type="submit"
          >
            {{$t("app.forget.complete")}}
          </van-button>
        </div>
      </van-form>
    </div>
 
      <van-dialog
        v-model="showModal"
        :show-cancel-button="true"
        :cancel-button-text="$t('app.common.cancel')"
        :confirm-button-text="$t('app.common.confirm')"
        :before-close="getPhoneCode"   
      >
      <van-cell-group>
        <van-field type="text" v-model="realName" :label="$t('app.forget.real_name')" :placeholder="$t('app.forget.real_name_placeholder')" />
   
        <van-field type="text" v-model="card" :label="$t('app.forget.card')" :placeholder="$t('app.forget.card_placeholder')" />
      </van-cell-group>
    </van-dialog>
  </div>
</template>

<script>
import JSEncrypt from "jsencrypt/bin/jsencrypt";
export default {
  name: "Forget",
  data() {
    return {
      phone: "",
      sms: "",
      password: "",
      verify: "",
      disabled: false,
      getCodeText: this.$t('app.forget.get_code'),
      captcha: "",
      rePicCode: "",
      verify_token: "",
      showModal:false,
      realName:'',
      card:''
    };
  },
  methods: {
    getRealName(){
      let that = this;
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(that.phone)) {
        that.$toast.fail(this.$t('app.common.phone_wrong_format'));
      } else {
        that.$http({
        url: "/",
        method: "post",
        data: {
          nozzle: "realname_verification",
          phone: that.phone
        },
      })
        .then(function(res) {
          let resData = res.data;
          if (resData.code == 1) {
            that.showModal=true;
          } else if (resData.code == 0) {
            that.disabled = false;
            that.$toast.fail(that.$t(res.data.msg));
            
          }
        });
    
      }
    },
     getCaptcha() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "getSmsPic",
          },
        })
        .then(function (res) {
          let resData = res.data;
          if (resData.code == 1) {
            that.captcha = resData.data.code_url;
            that.verify_token = resData.data.verify_token;
          } else if (resData.code == 0) {
            that.disabled = false;
            that.$toast.fail(that.$t(res.data.msg));
          }
        });
    },
    // add public key encryption code when no key in local storage
    getEncyptedPublicKey() {
      let encriptedPublicKey = localStorage.getItem("encript_public_key");

      if (!encriptedPublicKey) {
        let that = this;
        const toast = that.$ShowCommonLoading();
        that
          .$http({
            url: "/",
            method: "POST",
            data: {
              nozzle: "home",
            },
          })
          .then((ret) => {
            let resData = ret.data;
            if (resData.code === 1) {
              toast.clear();
              localStorage.setItem(
                "encript_public_key",
                resData.data.encript_public_key
              );
            } else {
              toast.clear();
              that.$toast.fail(that.$t(resData.msg));
            }
          })
          .catch(() => {
            toast.clear();
            that.$toast.fail(that.$NoNetworkErrorMsg);
          });
      }
    },
    onForget() {
      let that = this;
      if (that.password !== that.verify) {
        that.$toast.fail(this.$t('app.common.phone_wrong_format2'));
      } else if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(that.phone)) {
        that.$toast.fail(this.$t('app.common.phone_wrong_format'));
      } else {
        let publicKey = localStorage.getItem("encript_public_key");
        let userPhone = that.phone.toString();
        let forgetPhone = that.encryptMessage(userPhone, publicKey);
        let forgetPassword = that.encryptMessage(that.password, publicKey);
        let forgetPwConfirm = that.encryptMessage(that.verify, publicKey);
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "forgot_password_e",
              phone: forgetPhone,
              code: that.sms,
              password: forgetPassword,
              confirm: forgetPwConfirm,
            },
          })
          .then(function (res) {
            if (res.data.code == 1) {
              that.$toast({
                message: res.data.msg,
                type: "success",
                onClose: function () {
                  that.$router.push({
                    path: "/login",
                  });
                },
              });
            } else if (res.data.code == 0) {
              that.$toast.fail(that.$t(res.data.msg));
            }
          });
      }
    },
    getPhoneCode(action,done) {
      let that = this;
      switch(action){
        case 'confirm':
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(that.phone)) {
        that.$toast.fail(this.$t('app.common.phone_wrong_format'));
        done();
      } else {
        
        let publicKey = localStorage.getItem("encript_public_key");
        let userPhone = that.phone.toString();
        let phoneNumber = that.encryptMessage(userPhone, publicKey);
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "forgot_code_e",
              phone: phoneNumber,
              rePicCode: that.rePicCode,
              verify_token: that.verify_token,
              realname:that.realName,
              card:that.card
            },
          })
          .then(function (res) {
            if (res.data.code == 1) {
              that.$toast({
                message: res.data.msg,
                type: "success",
              });
              var time = 60;
              that.getCodeText = time + "s";
              that.disabled = true;
              var timer1 = setInterval(function () {
                time--;
                that.getCodeText = time + "s";
                if (time <= 0) {
                  that.getCodeText = "获取验证码";
                  that.disabled = false;
                  clearInterval(timer1);
                }
              }, 1000);
              done();
            } else if (res.data.code == 0) {
              that.realName='';
              that.card='';
              done();
              that.$toast.fail(that.$t(res.data.msg));
            }
          });
          
      }
      break;
          case 'cancel':
            done();
            break;
    }
    },
    encryptMessage(message, publicKey) {
      const jsEncrypt = new JSEncrypt();
      jsEncrypt.setPublicKey(publicKey);
      return jsEncrypt.encrypt(message);
    },
    // isLogin() {
    //   let that = this;
    //   if (that.$store.state.loginType) {
    //     this.$router.push("/member");
    //   }
    // },
  },
  mounted: function () {
    this.getCaptcha()

    // this.isLogin();
    this.getEncyptedPublicKey();
  },
};
</script>

<style scoped>
.wrap {
  width: 90%;
  margin: 0 auto;
}
.logo {
  width: 50%;
  margin: 100px auto 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Forget.vue